import * as yup from 'yup';
import svStrings from '../../../sv-strings';
import { Field, FIELD_TYPES, UIschema } from '../../../types';
import { MatchConfig, MatchConfigHidePlayerStats } from './utils/data';

export const getEditMatchConfigSchema = (matchConfig?: MatchConfig): UIschema => ({
  name: 'Match settings',
  fields: [
    {
      id: 'skipPush',
      type: FIELD_TYPES.SWITCH,
      key: 'skipPush',
      value: !!matchConfig?.skipPush,
      title: svStrings.matches.pauseNotifications,
      validation: yup.boolean(),
    },
    {
      id: 'hideBallPossesion',
      type: FIELD_TYPES.SWITCH,
      key: 'hideBallPossesion',
      value: !!matchConfig?.hideStats?.ballPossesion,
      title: svStrings.matches.hideBallPossesion,
      validation: yup.boolean(),
    },
    {
      id: 'hideDistance',
      type: FIELD_TYPES.SWITCH,
      key: 'hideDistance',
      value: !!matchConfig?.hideStats?.distance,
      title: svStrings.matches.hideDistance,
      validation: yup.boolean(),
    },
    {
      id: 'hideMatchTime',
      type: FIELD_TYPES.SWITCH,
      key: 'hideMatchTime',
      value: !!matchConfig?.hideMatchTime,
      title: svStrings.matches.hideMatchTime,
      validation: yup.boolean(),
    },
    {
      id: 'showInterruptedMatchInformation',
      type: FIELD_TYPES.SWITCH,
      key: 'showInterruptedMatchInformation',
      value: !!matchConfig?.showInterruptedMatchInformation,
      title: svStrings.matches.showInterruptedMatchInformation,
      validation: yup.boolean(),
    },
    {
      id: 'interruptedMatchText',
      type: FIELD_TYPES.TEXT,
      key: 'interruptedMatchText',
      value: matchConfig?.interruptedMatchText,
      title: svStrings.matches.interruptedMatchText,
      numRows: 3,
    },
  ] as Field[],
});

export const getEditPlayerConfigSchema = (playerConfig?: MatchConfigHidePlayerStats): UIschema => ({
  name: 'Player settings',
  fields: [
    {
      id: 'hideMaxSpeed',
      type: FIELD_TYPES.SWITCH,
      key: 'hideMaxSpeed',
      value: !!playerConfig?.maxSpeed,
      title: svStrings.matches.hideMaxSpeed,
      validation: yup.boolean(),
    },
    {
      id: 'hideDistance',
      type: FIELD_TYPES.SWITCH,
      key: 'hideDistance',
      value: !!playerConfig?.distance,
      title: svStrings.matches.hideDistance,
    },
  ] as Field[],
});
